import React from 'react'
import Navbar from '../components/Navbar'
import ScrollWrap from '../components/ScrollWrap'
import MainWrap from '../components/MainWrap'
import ContactFormWrap from '../components/ContactFormWrap'
import Overlay from '../components/Overlay'
import FundamentalCourses2 from '../components/FundamentalCourses2'
import Enroll from '../components/Enroll'
import CounterArea from '../components/CounterArea'
import DataSciVizData from '../data/DataSciVizData'
import DataSciVizData2 from '../data/DataSciVizData2'
import RelatedCourses from '../components/RelatedCourses'
import Footer from '../components/Footer'
import { CounterData2 } from '../data/CounterData'
import { EnrollData, EnrollData4 } from '../data/EnrollData'
import SlickSlider2 from '../components/SlickSlider2'
import { SlickDataSciData } from '../data/SlickSliderData'
import ContactAnchor from '../components/ContactAnchor'
import LoginAnchor from '../components/LoginAnchor'

export default function DataScienceVisualizaton() {
    return (
        <>
            <ContactAnchor />
            <LoginAnchor />
            <ScrollWrap />
            <Navbar />
            <MainWrap />
            <ContactFormWrap />
            <Overlay />
            <SlickSlider2 data={SlickDataSciData}/>
            <FundamentalCourses2  data={DataSciVizData}/>
            <CounterArea data={CounterData2}/>
            <Enroll data={EnrollData4} />
            <FundamentalCourses2 data={DataSciVizData2} />
            <Enroll data={EnrollData}/>
            <RelatedCourses />
            <Footer />
        </>
    )
}
